<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editData" ref="editDataRef" label-width="180px">
        <el-form-item label="折合人数" class="addAdminForm">
          <el-input v-model="editData.Numberofpeople" placeholder="请输入折合人数"></el-input>
        </el-form-item>
        <el-form-item label="应发工资" class="addAdminForm">
          <el-input v-model="editData.Salary" placeholder="请输入应发工资"></el-input>
        </el-form-item>
        <el-form-item label="个人社保" class="addAdminForm">
          <el-input v-model="editData.Personalshebao" placeholder="请输入个人社保"></el-input>
        </el-form-item>
        <el-form-item label="个人公积金" class="addAdminForm">
          <el-input v-model="editData.Personalgongjijin" placeholder="请输入个人公积金"></el-input>
        </el-form-item>
        <el-form-item label="单位社保" class="addAdminForm">
          <el-input v-model="editData.Companyshebao" placeholder="请输入单位社保"></el-input>
        </el-form-item>
        <el-form-item label="单位公积金" class="addAdminForm">
          <el-input v-model="editData.Companygongjijin" placeholder="请输入单位公积金"></el-input>
        </el-form-item>
        <el-form-item label="个税" class="addAdminForm">
          <el-input v-model="editData.Incometax" placeholder="请输入个税"></el-input>
        </el-form-item>
        <el-form-item label="实发工资" class="addAdminForm">
          <el-input v-model="editData.Actualsalary" placeholder="请输入实发工资"></el-input>
        </el-form-item>
        <el-form-item label="实付社保" class="addAdminForm">
          <el-input v-model="editData.Actualshebao" placeholder="请输入实付社保"></el-input>
        </el-form-item>
        <el-form-item label="实付公积金" class="addAdminForm">
          <el-input v-model="editData.Actualgongjijin" placeholder="请输入实付公积金"></el-input>
        </el-form-item>
        <el-form-item label="人工社保支出合计" class="addAdminForm">
          <el-input v-model="editData.Actualtotal" placeholder="请输入人工社保支出合计"></el-input>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickback">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editData: {}
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.editData = parentdata
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditPersonpayroll()
    },
    apiEditPersonpayroll: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        personpayrollid: that.editData.Id,
        numberofpeople: that.editData.Numberofpeople,
        salary: that.editData.Salary,
        personalshebao: that.editData.Personalshebao,
        personalgongjijin: that.editData.Personalgongjijin,
        companyshebao: that.editData.Companyshebao,
        companygongjijin: that.editData.Companygongjijin,
        incometax: that.editData.Incometax,
        actualsalary: that.editData.Actualsalary,
        actualshebao: that.editData.Actualshebao,
        actualgongjijin: that.editData.Actualgongjijin,
        actualtotal: that.editData.Actualtotal
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditPersonpayroll, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
</style>
